//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux';

//firebase
import { db, storage } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableBody";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
//import IconButton from "@material-ui/core/IconButton";
import CustomSelect from "components/Select/Select.jsx";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//spiffy
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";
import MaterialEditor from "components/MaterialEditor/MaterialEditor.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class SupportMaterials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materials: [],
      filtered: [],
      typeFilter: "all",
      quarterFilter: "all"
    }

    this.materialAdded = this.materialAdded.bind(this);
    this.materialUpdated = this.materialUpdated.bind(this);
  }

  componentDidMount() {
    this.refresh();
  }

  materialAdded(material) {
    var materials = this.state.materials;
    materials.push(material);
    this.setState({materials: materials});
  }

  materialUpdated(material) {
    var materials = this.state.materials;
    for(var i = 0; i < materials.length; i++) {
      if(materials[i].id === material.id) {
        materials[i] = material;
        break;
      }
    }
    this.setState({materials: materials});
  }

  deleteFile(fileName, callback) {
    if(fileName) {
      storage.downloads.child(fileName).delete().then(() => {
        callback();
      }).catch(function(error) {
        console.log('unable to delete file');
        callback();
      });
    } else {
      callback();
    }
  }

  deleteMaterial(material) {
    
    this.deleteFile(material.FileName, () => {
      db.deleteMaterial(material.id).then(() => {
        var materials = this.state.materials;
        for(var i = 0; i < materials.length; i++) {
          if(materials[i].id === material.id) {
            materials.splice(i,1);
            break;
          }
        }
        this.setState({materials: materials});
      });
    });
  }

  refresh() {

    if (this.props.user.authenticated) {
      
      db.getMaterials(this.props.org.id).then(snapshot => {

        var objs = [];
        snapshot.forEach((doc) => {
          
          var obj = doc.data();
          obj.id = doc.id;
          objs.push(obj);
        });
        
        this.setState({materials:objs, filtered: objs});
      });
    }
  }


  filterMaterials(type, quarter) {

    var objs = this.state.materials;
    var filtered = [];

    for(var i = 0; i < objs.length; i++) {
      if(objs[i].Type === type || type === 'all') {
        if(objs[i].Quarter === quarter || quarter === 'all')
          filtered.push(objs[i]);
      }
    }

    this.setState({filtered: filtered, typeFilter: type, quarterFilter: quarter})
  }

  showType() {
    if(this.state.typeFilter === 'all')
      return "table-cell";
    else
      return "none";
  }

  getQuarter(quarter) {
    if(quarter === 0)
      return 'n/a';
    else 
      return quarter;
  }

  getVisibleDescriptor(visible) {
    if(visible)
      return <div style={{color:"green"}}>Yes</div>;
    else
      return <div style={{color:"gray"}}>No</div>;
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("app.allthingseq.com/supportMaterials");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Support Materials</h4>
                  <p className={classes.cardCategoryWhite}>
                    High level support materials not constrained to a specific insight.
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                        id="tooltip-top-start"
                        title="Add Material"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                      >
                      <MaterialEditor onNew={this.materialAdded}
                       material={{
                          Name: "",
                          Description: "",
                          Type: "General",
                          orgId: this.props.org.id
                        }} 
                      />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomSelect
                    labelText="Type"
                    value={this.state.typeFilter}
                    inputProps={{
                        placeholder: "Type"
                    }}
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={(e) => this.filterMaterials(e.target.value, this.state.quarterFilter)}
                    options={[ {key:"all", label:"All"}, {key:"general", label:"General" }, {key:"counselor", label:"Counselor" }, { key:"posters", label:"Posters" }, { key:"teams", label:"TEAMS" } ]}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomSelect
                    labelText="Quarter"
                    value={this.state.quarterFilter}
                    inputProps={{
                        placeholder: "Quarter"
                    }}
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={(e) => this.filterMaterials(this.state.typeFilter, e.target.value)}
                    options={[ {key:"all", label:"All"}, {key:0, label:"n/a" }, {key:1, label:"Q1" }, { key:2, label:"Q2" }, { key:3, label:"Q3" }, { key:4, label:"Q4" } ]}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    
                </GridItem>
              </GridContainer>
              <GridItem xs={12} sm={12}>
                <Table className={classes.table} style={{marginTop:"50px"}}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{width:"34px", padding:"3px"}}>

                      </TableCell>
                      <TableCell style={{width:"34px", padding:"3px"}}>
                        Quarter
                      </TableCell>
                      <TableCell style={{display:this.showType()}}>
                        Type
                      </TableCell>
                      <TableCell>
                        Name
                      </TableCell>
                      <TableCell>
                        Visible
                      </TableCell>
                      <TableCell style={{width:"34px", padding:"3px"}}>
                        
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.filtered.map(value => (
                      <TableRow key={value.id} className={classes.tableRow}>
                        <TableCell className={classes.tableActions} style={{width:"34px", padding:"3px"}}>
                          <Tooltip
                            id="tooltip-top"
                            title="Edit Support Material"
                            placement="top"
                            classes={{ tooltip: classes.tooltip }}
                          >
                            <MaterialEditor material={value} onChange={this.materialUpdated} />
                          </Tooltip>
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{width:"34px", padding:"3px", textAlign:"center"}}>
                          {this.getQuarter(value.Quarter)}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{display:this.showType()}}>
                          {value.Type}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {value.Name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {this.getVisibleDescriptor(value.IsVisible)}
                        </TableCell>
                        <TableCell className={classes.tableActions} style={{width:"34px", padding:"3px", textAlign:"center"}}>
                          <Tooltip id="tooltip-top-start" title="Delete Support Material" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this support material? This action cannot be undone." confirmed={() => this.deleteMaterial(value)} />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </GridItem>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

SupportMaterials = connect(mapStateToProps)(SupportMaterials);
export default withStyles(styles)(SupportMaterials);



// WEBPACK FOOTER //
// ./src/views/SupportMaterial/SupportMaterial.jsx